import { QueryClient } from "@tanstack/react-query";

// Defaults are tuned for the CPI dashboard's caching needs (see
// docs/superpowers/specs/2026-05-11-cpi-react-query-cache-design.md):
// - staleTime Infinity so a successful fetch within a session is never
//   considered stale; only explicit invalidateQueries triggers a refetch.
// - cacheTime 30min keeps unsubscribed cache entries around long enough for
//   human-paced sub-tab bounces. (react-query v4 uses cacheTime; v5 renamed
//   it gcTime — using gcTime here would be silently ignored and fall back to
//   the 5-minute default, breaking the tab-bounce reuse promise.)
// - All automatic refetch / retry behaviors disabled so the page behaves
//   predictably and doesn't surprise the user with background loads.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: false,
    },
  },
});
